import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_time_selector_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { fullTextSearch?: string, intervalMinutes: number, $top?: number, $skip?: number }): Promise<{ result?: { time?: string }[], totalCount?: number }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.intervalMinutes)) {
      missingRequiredInParams.push('\'intervalMinutes\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_time_selector_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { fullTextSearch?: string, intervalMinutes?: number, $keys: string[] }): Promise<{ result?: { time?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_time_selector_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      fullTextSearch?: string, intervalMinutes: number    }) {
        if(isNil(inParams.intervalMinutes)) {
          return true; 
        }
      return false;
    }
}
